module.exports = __webpack_public_path__ + "static/media/16-Knightsbridge.a0e762e9.mp4";